import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  const styles = {
    title: {
      color: "#ffcd00",
      fontSize: "64px",
      lineHeight: "64px",
      fontWeight: 800,
      fontFamily: "sans-serif",
    },
    link: {
      padding: "20px 26px",
      borderRadius: "10px",
      backgroundColor: "#ffcd00",
      color: "#383838",
      fontSize: "15px",
      fontWeight: 700,
      lineHeight: "20px",
      textDecoration: "none",
    },
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#fafafa",
      }}
    >
      <h1 style={styles.title}>
        404 <br /> You’ve Gone One <br /> Tap Too Far
      </h1>
      <h5>Oops, looks like you’re a little lost... Let’s get you off this old page and back to business!</h5>
      <Link style={styles.link} to="/cnp">
        Go back home
      </Link>
    </div>
  );
};

export default NotFound;
